<!--
 * @Description:
 * @Date: 2019-03-15 10:04:20
 -->
<template>
  <div class="table-box">
    <!--查询-->
    <searchbar :searchEvent="searchEvent.bind(this)" :parent="this" />
    <!--列表-->
    <div>
      <el-table
        style="width: 100%"
        v-loading="loading"
        row-key="id"
        ref="recordList"
        :data="tableData"
        :stripe="false"
        :highlight-current-row="false"
        header-row-class-name="noBorder"
      >
        <!-- <el-table-column
          type="selection"
          width="55"
          row-key="id"
          :reserve-selection="true"
        ></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <!-- <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="任务月度"
        >
          <template slot-scope="scope">{{scope.row.taskDt|transMonth2}}</template>
        </el-table-column> -->
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="hospitalName"
          label="医院名称"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="hospitalAddress"
          label="医院地址"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="product_name"
          label="产品名称"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="guige"
          label="产品规格"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="enterprise"
          label="生产厂商"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="firstHospitalMonth"
          label="首次进院月份"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="首次进货流向"
          prop="pics1"
          v-for="(item, index) in 3"
          :key="`pics1-${index}`"
        >
          <template slot-scope="scope">
            <p v-if="showHr(getImgArr(scope.row['pics1'])[index], 1)">—</p>
            <img
              v-else
              class="table-pic"
              @click="clickPic(scope, index)"
              :src="getImgArr(scope.row['pics1'])[index]"
              alt
            />
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="医院进院批准"
          prop="pics2"
          v-for="(item, index) in 3"
          :key="`pics2-${index}`"
        >
          <template slot-scope="scope">
            <p v-if="showHr(getImgArr(scope.row['pics2'])[index], 1)">—</p>
            <img
              v-else
              class="table-pic"
              @click="clickPic(scope, index)"
              :src="getImgArr(scope.row['pics2'])[index]"
              alt
            />
          </template>
        </el-table-column>
        <el-table-column label="补充" width="150" align="center" prop="pics4">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="
                clickPic(
                  scope,
                  scope.row['pics4'].findIndex(item => item)
                )
              "
              v-if="showZlpic(scope.row['pics4'])"
            >
              查看
            </el-button>
            <div v-else>无</div>
          </template>
        </el-table-column>
        <el-table-column
          label="服务商审核人"
          align="center"
          v-if="showReviewer"
        >
          <template slot-scope="scope">
            {{ dealReviewer(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="状态"
        >
          <template slot-scope="scope">
            {{ scope.row.auditGongyeStatus | transAuditStatus }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="check(scope.row)">查看</el-button> -->
            <el-button
              :disabled="scope.row.auditGongyeStatus !== 1"
              type="text"
              size="small"
              @click="approve(2, scope.row)"
            >
              通过
            </el-button>
            <rejectComponent
              :disabled="scope.row.auditGongyeStatus !== 1"
              @withdraw="item => approve(3, scope.row, 0, item)"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="check(scope.row)">详情</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
    <el-dialog
      class="table-dialog"
      title="提示"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div slot="title"></div>
      <el-carousel
        v-if="dialogVisible"
        :arrow="showArrow ? 'hover' : 'never'"
        trigger="click"
        :autoplay="false"
        :initial-index="carouselIndex"
        height="65vh"
      >
        <el-carousel-item v-for="item in imagesList" :key="item">
          <!--          <div style="height: 100%">-->
          <img class="show-modal-ca" :src="item || '#'" alt />
          <!--          </div>-->
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
// import datePicker from "@/Mixin/datePicker";
import { project, receive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import { mapState } from 'vuex';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import searchbar from '@/components/Survey/searchbar';
import rejectComponent from '@/components/Task/components/reject.vue';
import OpenNewWin from '@/tools/openNewWin';
import approvalFlagMixins from '@/Mixin/approvalFlagMixins';

export default {
  mixins: [pageInation, makeSure, taskRecordHandles, approvalFlagMixins],
  data() {
    return {
      showArrow: true,
      carouselIndex: 0,
      dialogVisible: false,
      imagesList: [],
      authType: 0,
      ruleForm: {}, // 用户信息
      getList: project.hospitalOrOtcMarketAccessList, // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskMonth: this.$route.query.month,
        projectType: '',
        statementId: this.$route.query.statementId
      },
      prop: {
        label: 'projectName',
        code: 'id'
      },
      searchAjax: project.crmProjectList,
      extraObj: {
        type: 1
      }
    };
  },
  components: {
    dicSelect,
    searchbar,
    rejectComponent
  },
  computed: {
    // tableDataC() {
    //   return (
    //     [
    //       {
    //         id: 1,
    //         pics1: [
    //           "http://ht.liangjiyuhe.com/upload/portal/20191015/989c6c999780c77370e512a1d423e1f4.jpg",
    //           "http://hantang.140128.top/30293e.png?v=0.1.3"
    //         ],
    //         pics2: []
    //       }
    //     ] || this.tableData
    //   );
    // },
    getImgArr() {
      return arr => {
        return arr || [];
      };
    },
    showHr(imgArr, index) {
      return (imgArr, index) => {
        return !imgArr || !imgArr[index] || imgArr[index] == 'null';
      };
    },
    showZlpic() {
      return zlpic => {
        return zlpic && zlpic.length > 0 && zlpic.find(item => item);
      };
    },
    ...mapState({
      projectType: state => state.homeProject.projectType
    })
  },
  methods: {
    check(row) {
      let { id } = this.$route.query;
      this.$router.push({
        name: 'recordAcademylDetail',
        query: {
          questionnaireAnswerId: row.id,
          authType: this.authType,
          detailId: row.id,
          id,
          visitTime: row.startDt,
          statementId: this.$route.query.statementId,
          auditGongyeStatus: row.auditGongyeStatus
        }
      });
    },
    clickPic(scope, index, arrow) {
      let { row, column } = scope;
      let property = column.property || '';
      let target = row[property];
      if (!Array.isArray(target)) {
        target = [target];
      }
      let curr = index;
      this.imagesList = target.filter((res, idx) => {
        if (!res || res === 'null') {
          if (idx < curr) {
            curr--;
          }
        }
        return res && res !== 'null';
      });
      this.dialogVisible = true;
      this.showArrow = this.imagesList.length > 1;
      this.carouselIndex = curr || 0;
    },
    dateChange(val) {},
    saveProId(val) {
      this.searchQuery.projectId = val.id;
    },
    exportEvent() {
      if (this.searchQuery.projectId && this.searchQuery.taskMonth) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(
          project.exportHospitalOrOtcMarketAccessList + '?' + queryString
        );
      } else {
        this.$message.error('请选择条件');
      }
    },
    saveEnterpriseId(val) {
      //保存
      this.searchQuery.enterpriseId = val.id;
    },
    add() {
      this.$router.push({
        name: 'salerAdd'
      });
    },
    pass(scope, status) {
      let delEvent = scope => {
        let { $index, row } = scope;
        visit
          .pass({
            id: row.id,
            status
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(delEvent, scope);
    }
  },

  mounted() {
    this.authType = +(localStorage.getItem('authType') || 0);
    // console.log(this.authType,21222)
  },
  created() {
    this.searchQuery.projectType = this.projectType;
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
.table-dialog {
  .el-carousel__item {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      /*max-height: 600px;*/
      height: inherit;
    }
  }
}

.table-pic {
  object-fit: contain !important;
}

.show-modal-ca {
  /*width: 100%!important;*/
  height: 100% !important;
  object-fit: contain !important;
}
</style>
